import React, { useCallback }  from 'react'
import { useLocation, Location, useNavigate } from 'react-router-dom'
import { Box, Flex, Button, Text } from '@chakra-ui/react'
import { ChevronLeftIcon } from '@chakra-ui/icons'
import { themeChakra } from '@wow/themes'

import buttonStyle from '../../Theme/components/buttonStyle'
import CheckboxTyC from 'components/checkboxTyC/checkboxTyC'

interface IFooterReferralsProps {
  stepNumber: string
  textContinue?: string
  disableContinue?: boolean
  disableBack?: boolean
  onAction?: (e?: React.MouseEvent<HTMLButtonElement>) => void
  onBackButton?: () => void
  documentTyC?: string,
  showTyC?: boolean
  isTyCChecked?: boolean
  onChangeTyC?: (e?: boolean) => void
}

const FooterReferrals = ({
  stepNumber,
  textContinue = 'Continuar',
  disableContinue = false,
  disableBack = false,
  onAction = () => { },
  onBackButton = () => { },
  documentTyC = '',
  showTyC = false,
  isTyCChecked = false,
  onChangeTyC = () => { },
}: IFooterReferralsProps) => {
  const location: Location = useLocation()
  const showBackButton = location.pathname.split('/')[1] !== 'referir-empresa' && location.pathname.split('/')[1] !== ''
  const navigate = useNavigate()
  

  const backStep = useCallback( () => {
    onBackButton()
    navigate(-1)
  },[onBackButton])
  

  return (
    <Flex
      justifyContent='space-between'
      backgroundColor='white'
      align='center'
      p='20px 60px'
      boxShadow='0px -4px 6px 0px rgba(0,0,0,0.1)'
      position='fixed'
      bottom={0}
      width='100vw'
      color='white'
      zIndex={10}
    >
      <Box w='200px'>
        {showBackButton && (
          <Button
            data-testid='form-back'
            variant='link'
            leftIcon={<ChevronLeftIcon boxSize={6} />}
            color={themeChakra.colors.tertiary[100]}
            onClick={backStep}
            isDisabled={disableBack}
          >
            Volver
          </Button>
        )}
      </Box>
      {showTyC && 
        <Flex alignItems='center' w='400px' justifyContent='center'>
          <CheckboxTyC isRequired onChangeTyC={onChangeTyC} isChecked={isTyCChecked} documentTyC={documentTyC} />
        </Flex>
      }
      <Flex alignItems='center' w='200px'>
        <Text textStyle='labelLg' color='secondary.100' mr={8}>{`Paso ${stepNumber} de 3`}</Text>
        <Button data-testid='form-continue' isDisabled={disableContinue} style={buttonStyle.buttonPurple} type='submit' onClick={onAction}>
          {textContinue}
        </Button>
      </Flex>
    </Flex>
  )
}

export default FooterReferrals
